"use strict";

define('app/app.view',['rs/abstract.app.view'], function (AppView) {
  var IRBAppView = AppView.extend({});
  return IRBAppView;
});

